import { z } from "zod";

/**
 * DTO for checking wallet age eligibility for DEX campaign participation
 * Wallets must have a transaction older than 2 weeks to be eligible
 */
export const checkWalletAgeEligibilitySchema = z.object({
  walletAddress: z.string().min(1, "Wallet address is required"),
});

export type CheckWalletAgeEligibility = z.infer<typeof checkWalletAgeEligibilitySchema>;
